import Swiper from "swiper";
import { breakpoints } from "./config";

new Swiper(".js-el__product-carousel", {
	slidesPerView: 'auto',
	scrollbar: {
		el: ".js-el__product-carousel-scrollbar",
		hide: false,
		draggable: true,
		dragSize: "180px"
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}

	/*,
	breakpoints: {
		[breakpoints.m]: {
			slidesPerView: 'auto'
		}
	}
	*/
});
